import React from "react";
import { FaMugHot } from "react-icons/fa";
import { SelectableCard } from "../../atoms";
import { MascotLoadingOverlay } from "../../shared";

/**
 * Firma oluşturma — 3. adım: aktif başlayacak ürünler (#275).
 * Seçilmeyen ürünler firmaya eklenir ama kota dağıtımı kapalı başlar.
 *
 * @param {string[]} products  ürün tipi adları
 * @param {string[]} selected  aktif başlayacaklar
 * @param {(next: string[]) => void} onChange
 */
export default function FirmProductsStep({
  products,
  selected,
  onChange,
  isLoading,
  isError,
  error,
}) {
  const selectedSet = new Set(selected || []);
  const toggle = (name) =>
    onChange(
      selectedSet.has(name)
        ? products.filter((p) => p !== name && selectedSet.has(p))
        : products.filter((p) => p === name || selectedSet.has(p)),
    );

  if (isLoading) {
    return (
      <div className="relative grid grid-cols-1 sm:grid-cols-2 gap-3 min-h-[12rem]">
        <MascotLoadingOverlay message="Ürünler yükleniyor..." />
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-[4.5rem] rounded-2xl bg-gray-100 animate-pulse" />
        ))}
      </div>
    );
  }

  if (isError) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-sm text-amber-800">
        Ürün listesi alınamadı. Firma <span className="font-SemiBold">tüm ürünler açık</span>{" "}
        olarak oluşturulur; kullanılmayanları sonra firma detayındaki ürün ayarlarından
        kapatabilirsiniz.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="bg-gray-50 rounded-lg p-4">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <h3 className="text-base font-SemiBold text-gray-800">Aktif Ürünler</h3>
            <p className="text-sm text-gray-500 mt-1">
              Firmanın kullanacağı ürünleri seçin. Seçilmeyenler{" "}
              <span className="font-SemiBold text-gray-700">kota dağıtımı kapalı</span> başlar.
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <span className="text-gray-500">
              {selectedSet.size} / {products.length} seçili
            </span>
            <button
              type="button"
              onClick={() => onChange([...products])}
              className="px-2.5 py-1 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
            >
              Tümünü seç
            </button>
            <button
              type="button"
              onClick={() => onChange([])}
              className="px-2.5 py-1 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
            >
              Temizle
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {products.map((name) => {
          const on = selectedSet.has(name);
          return (
            <SelectableCard
              key={name}
              icon={FaMugHot}
              title={name}
              subtitle={on ? "Kota dağıtımı açık" : "Kapalı başlar"}
              selected={on}
              onClick={() => toggle(name)}
            />
          );
        })}
      </div>

      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
}
